import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { CondReglService } from 'src/app/shared/services/simple/cond-regl.service';
import { GestionCondReglComponent } from './../../../../core/gestion-referentiel/gestion-cond-regl/gestion-cond-regl.component';
import { CondReglModel } from './../../../models/simple-types/cond-regl.model';
import { Form, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Component, OnInit, Inject, OnChanges } from '@angular/core';

export interface DialogData {
        form: UntypedFormGroup;
        condRegls: CondReglModel[];
        result: boolean;
      }
@Component({
  selector: 'app-modal-add-cond-regl',
  templateUrl: './modal-add-cond-regl.component.html',
  styleUrls: ['./modal-add-cond-regl.component.scss']
})
export class ModalAddCondReglComponent implements OnInit {

  condRegls: CondReglModel[];
  form: UntypedFormGroup;
  constructor(public dialog: MatDialog
            , public dialogRef: MatDialogRef<GestionCondReglComponent>
            , @Inject(MAT_DIALOG_DATA) public data: DialogData
            , private toastr: ToastrService
            , private router: Router
            , private condReglService: CondReglService) {
          }

  ngOnInit(): void {
    this.condRegls = this.data.condRegls;
    this.form = this.data.form;
  }

  onModalCancel(): void {
    this.data.result = false;
    this.dialogRef.close(false);
  }

  onModalConfirm(): void {
    if (this.form.valid) {
      const condRegl = this.form.getRawValue();
      // Création
      if (!this.form.get('id').value){
        const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.condReglService.save(condRegl).subscribe((a: CondReglModel) => {
            this.toastr.success('', 'Création de la condition de réglement ' + a.code + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(true);
            dialogRef.close();
          });
      }else { // Modification
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.condReglService.update(condRegl.id, condRegl).subscribe((a: CondReglModel) => {
          this.toastr.success('', 'Modification de la condition de réglement ' + a.code + ' réussie');
          this.dialogRef.close(true);
          dialogRef.close();
        }, (error) => {
          this.dialogRef.close(true);
          dialogRef.close();
        });
      }
    } else {
      this.displayErrors();
    }
  }

  displayErrors(): void {
    for (const index in this.form.controls) {
      if (index) {
        this.form.controls[index].markAsTouched();
      }
    }
  }

}


